import axios from 'axios';
import routes from 'app/routes';

const prepareFormDataForSend = (values) => ({
  first_name: values.firstName,
  last_name: values.lastName,
  email: values.email,
  company: values.company,
  website: values.website,
  phone: values.phone,
  jobtitle: values.jobTitle,
});

export default {
  load: (dispatch, filters) => {
    const params = {};
    if (filters.affiliateId) {
      params['q[affiliate_id_eq]'] = filters.affiliateId;
    }
    axios.get(
      routes.api.affiliates.prospects.index,
      { params },
    ).then((resp) => {
      dispatch({ type: 'LOAD', prospects: resp.data.data });
    });
  },
  showEditForm: (dispatch, prospect) => {
    dispatch({ type: 'SELECT_PROSPECT', prospect });
  },
  hideModal: (dispatch) => {
    dispatch({ type: 'CLOSE_MODAL' });
  },
  save: (dispatch, prospectId, values, successCallback, errorCallback) => {
    axios
      .patch(routes.api.affiliates.prospects.update(prospectId), {
        affiliate_prospect: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        dispatch({ type: 'UPDATE', prospect: resp.data.data });
        successCallback();
      })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },

  delete: (dispatch, prospectId) => {
    axios
      .delete(routes.api.affiliates.prospects.destroy(prospectId))
      .then((resp) => {
        dispatch({ type: 'UPDATE', prospect: resp.data.data });
      });
  },

};
